<template>
  <div>
    <div class="ccui-navigation">
      <el-button
        size="mini"
        type="primary-icon-medium"
        icon="icon-ccui-return"
        @click="handleBack"
        >返回</el-button
      >
      <div class="ccui-navigation-divider" />
      <!-- 面包屑 -->
      <el-breadcrumb
        class="ccui-navigation-crumbs-container"
        separator-class="el-icon-arrow-right"
      >
        <el-breadcrumb-item
          :to="{ path: $store.getters.getBreadcrumb('level1').path }"
          >{{ $store.getters.getBreadcrumb("level1").name }}</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/pcconcsub/item-list' }"
          >代码生成</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/pcconcsub/item-list' }"
          >分包合同</el-breadcrumb-item
        >
        <el-breadcrumb-item>
          <span class="ccui-curr-crumb">新增分包合同</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="ccui-app-container-detail">
      <div class="ccui-app-container-detail-body">
        <pcConcSub ref="pcConcSub"></pcConcSub>
        <pcConcSubList ref="pcConcSubList"></pcConcSubList>
        <pcConcSubProtocol ref="pcConcSubProtocol"></pcConcSubProtocol>
        <pcConcSubDevice ref="pcConcSubDevice"></pcConcSubDevice>
        <pcConcSubOther ref="pcConcSubOther"></pcConcSubOther>
        <pcFinance ref="pcFinance"></pcFinance>
        <concFiles ref="concFiles"></concFiles>
      </div>
    </div>
    <el-bottom-guide>
      <ul class="ccui-bottom-button">
        <li>
          <el-button type="bottom" icon="icon-ccui-return" @click="handleBack"
            >返回</el-button
          >
        </li>
        <div class="ccui-bottom-guide-divider" />
        <li>
          <el-button type="bottom" icon="icon-ccui-save" @click="submitHandle"
            >保存</el-button
          >
        </li>
        <li>
          <el-button type="bottom" icon="icon-ccui-cancel" @click="resetHandle"
            >取消</el-button
          >
        </li>
      </ul>
    </el-bottom-guide>
  </div>
</template>

<script>
import { postAddPcConcSub } from "../../api/item-list";
import { ishasAgentId } from "@/basa/utils";
import pcConcSub from "./pcConcSub";
import pcConcSubList from "./pcConcSubList";
import pcConcSubProtocol from "./pcConcSubProtocol";
import pcConcSubDevice from "./pcConcSubDevice";
import pcConcSubOther from "./pcConcSubOther";
import pcFinance from "./pcFinance";
import concFiles from "./concFiles";

export default {
  name: "addPcConcSub",
  components: {
    pcConcSub,
    pcConcSubList,
    pcConcSubProtocol,
    pcConcSubDevice,
    pcConcSubOther,
    pcFinance,
    concFiles
  },
  data() {
    return {
      focus: "pcconcsub"
    };
  },
  methods: {
    // 返回
    handleBack() {
      this.$router.push("/pcconcsub/item-list");
    },
    // 清空输入框(取消)
    resetHandle() {
      this.$refs.pcConcSub.$refs.form.resetFields();

      this.$refs.pcConcSubList.tableData = [{ id: "1" }];
      this.$refs.pcConcSubProtocol.tableData = [{ id: "1" }];
      this.$refs.pcConcSubDevice.tableData = [{ id: "1" }];
      this.$refs.pcConcSubOther.tableData = [{ id: "1" }];
      this.$refs.pcFinance.$refs.form.resetFields();
      this.$refs.concFiles.tableData = [];
    },
    submitHandle() {
      var pass;
      pass = true;

      this.$refs.pcFinance.$refs.form.validate(valid => {
        if (valid) {
          pass = true;
        } else {
          this.errorLocation(this.$refs.pcFinance);
          pass = false;
          return false;
        }
      });
      //最后检查主表
      this.$refs.pcConcSub.$refs.form.validate(valid => {
        if (valid && pass) {
          this.add();
        } else {
          this.errorLocation(this.$refs.pcConcSub);
          pass = false;
          return false;
        }
      });
    },
    // 保存请求
    add() {
      //收集表数据
      var pcConcSub = {
        subContractType: this.$refs.pcConcSub.form.subContractType,

        subcontractName: this.$refs.pcConcSub.form.subcontractName,

        subcontractCode: this.$refs.pcConcSub.form.subcontractCode,

        bindingName: this.$refs.pcConcSub.form.bindingName,

        bindingTypeValue: this.$refs.pcConcSub.form.bindingTypeValue,

        bindingType: this.$refs.pcConcSub.form.bindingType,

        bindingDate:
          this.$refs.pcConcSub.form.bindingDate &&
          this.$refs.pcConcSub.form.bindingDate.substr(0, 10),

        scalingDate:
          this.$refs.pcConcSub.form.scalingDate &&
          this.$refs.pcConcSub.form.scalingDate.substr(0, 10),

        performanceBondAmt: this.$refs.pcConcSub.form.performanceBondAmt,

        performanceBondRate: this.$refs.pcConcSub.form.performanceBondRate,

        expirationTime:
          this.$refs.pcConcSub.form.expirationTime &&
          this.$refs.pcConcSub.form.expirationTime.substr(0, 10),

        isPayCash: this.$refs.pcConcSub.form.isPayCash,

        isPaidCash: this.$refs.pcConcSub.form.isPaidCash,

        commencementDate:
          this.$refs.pcConcSub.form.commencementDate &&
          this.$refs.pcConcSub.form.commencementDate.substr(0, 10),

        completedDate:
          this.$refs.pcConcSub.form.completedDate &&
          this.$refs.pcConcSub.form.completedDate.substr(0, 10),

        timeLimit: this.$refs.pcConcSub.form.timeLimit,

        partyBPerson: this.$refs.pcConcSub.form.partyBPerson,

        partyBPersonNo: this.$refs.pcConcSub.form.partyBPersonNo,

        partyBPersonTel: this.$refs.pcConcSub.form.partyBPersonTel,

        contractPushStatus: this.$refs.pcConcSub.form.contractPushStatus
      };
      var pcConcSubListList = [];
      if (this.$refs.pcConcSubList.tableData) {
        this.$refs.pcConcSubList.tableData.forEach(item => {
          pcConcSubListList.push({
            id: item.id,
            tPcConcSubId: item.tPcConcSubId,
            listResouce: item.listResouce,
            collectionObject: item.collectionObject,
            part: item.part,
            amountOfSubcontract: item.amountOfSubcontract,
            materialsCode: item.materialsCode,
            materialsName: item.materialsName,
            measuringUnit: item.measuringUnit,
            totalAmtExcludeTax: item.totalAmtExcludeTax,
            unitPriceExcludingTax: item.unitPriceExcludingTax,
            unitPriceIncludingTax: item.unitPriceIncludingTax,
            totalAmtIncludeTax: item.totalAmtIncludeTax,
            tax: item.tax,
            remark: item.remark,
            outstandingQuantity: item.outstandingQuantity,
            changeNum: item.changeNum,
            isAdjustTaxFlag: item.isAdjustTaxFlag
          });
        });
      }

      var pcConcSubProtocolList = [];
      if (this.$refs.pcConcSubProtocol.tableData) {
        this.$refs.pcConcSubProtocol.tableData.forEach(item => {
          pcConcSubProtocolList.push({
            id: item.id,
            tPcConcSubId: item.tPcConcSubId,
            changeEditPerson: item.changeEditPerson,
            signDate: item.signDate,
            signPlace: item.signPlace,
            initContractName: item.initContractName,
            initContractCode: item.initContractCode,
            partyAId: item.partyAId,
            partyBId: item.partyBId,
            protocolCode: item.protocolCode,
            protocolName: item.protocolName,
            protocolTaxRateCode: item.protocolTaxRateCode,
            protocolTaxRate: item.protocolTaxRate,
            nowPriceIncludeTax: item.nowPriceIncludeTax,
            nowTax: item.nowTax,
            nowPriceExcludeTax: item.nowPriceExcludeTax,
            compileDate: item.compileDate,
            takeEffectDate: item.takeEffectDate,
            contractPerson: item.contractPerson,
            priceFillingMethodValue: item.priceFillingMethodValue,
            priceFillingMethod: item.priceFillingMethod,
            mainTermsOfContract: item.mainTermsOfContract,
            remark: item.remark,
            isEnabled: item.isEnabled,
            isAdjustTaxFlag: item.isAdjustTaxFlag,
            contractState: item.contractState,
            checkState: item.checkState
          });
        });
      }

      var pcConcSubDeviceList = [];
      if (this.$refs.pcConcSubDevice.tableData) {
        this.$refs.pcConcSubDevice.tableData.forEach(item => {
          pcConcSubDeviceList.push({
            id: item.id,
            tPcConcSubId: item.tPcConcSubId,
            machineCode: item.machineCode,
            machineName: item.machineName,
            specifications: item.specifications,
            placeOfOrigin: item.placeOfOrigin,
            productionDate: item.productionDate,
            rateOfWork: item.rateOfWork,
            dateOfEntry: item.dateOfEntry,
            remark: item.remark
          });
        });
      }

      var pcConcSubOtherList = [];
      if (this.$refs.pcConcSubOther.tableData) {
        this.$refs.pcConcSubOther.tableData.forEach(item => {
          pcConcSubOtherList.push({
            id: item.id,
            tPcConcSubId: item.tPcConcSubId,
            projectCode: item.projectCode,
            projectName: item.projectName,
            count: item.count,
            measuringUnit: item.measuringUnit,
            totalAmtExcludeTax: item.totalAmtExcludeTax,
            unitPriceExcludingTax: item.unitPriceExcludingTax,
            unitPriceIncludingTax: item.unitPriceIncludingTax,
            totalAmtIncludeTax: item.totalAmtIncludeTax,
            tax: item.tax,
            taxRate: item.taxRate
          });
        });
      }

      var pcFinance = {
        province: this.$refs.pcFinance.form.province,

        city: this.$refs.pcFinance.form.city,

        county: this.$refs.pcFinance.form.county,

        deliverPlace: this.$refs.pcFinance.form.deliverPlace,

        taxMethodCode: this.$refs.pcFinance.form.taxMethodCode,

        taxMethod: this.$refs.pcFinance.form.taxMethod,

        invoiceTypeCode: this.$refs.pcFinance.form.invoiceTypeCode,

        invoiceType: this.$refs.pcFinance.form.invoiceType,

        contractNum: this.$refs.pcFinance.form.contractNum,

        materialSource: this.$refs.pcFinance.form.materialSource,

        materialSourceCode: this.$refs.pcFinance.form.materialSourceCode,

        payTheCoefficient: this.$refs.pcFinance.form.payTheCoefficient,

        prepayment: this.$refs.pcFinance.form.prepayment,

        signPlace: this.$refs.pcFinance.form.signPlace,

        contractPerson: this.$refs.pcFinance.form.contractPerson,

        businessType: this.$refs.pcFinance.form.businessType
      };
      var concFilesList = [];
      if (this.$refs.concFiles.tableData) {
        this.$refs.concFiles.tableData.forEach(item => {
          concFilesList.push({
            id: item.id,
            businessId: item.businessId,
            businessType: item.businessType,
            fileInfoId: item.fileInfoId,
            fileName: item.fileName,
            fileSize: item.fileSize,
            fileType: item.fileType,
            fileUrl: item.fileUrl,
            fileDesc: item.fileDesc
          });
        });
      }

      const obj = {
        pcConcSub: pcConcSub,
        pcConcSubList: pcConcSubListList,
        pcConcSubProtocol: pcConcSubProtocolList,
        pcConcSubDevice: pcConcSubDeviceList,
        pcConcSubOther: pcConcSubOtherList,
        pcFinance: pcFinance,
        concFiles: concFilesList,
        isShowLoading: true,
        loadingMessage: "保存中,请稍等..."
      };
      postAddPcConcSub(obj)
        .then(res => {
          let { code, message } = res.data;
          this.$message({
            message: message,
            type: code === "0" ? "success" : "error",
            // duration: code === "0" ? 3000 : '',
            showClose: true,
            ccuiCustom: true
          });
          if (code === "0") {
            this.submitFlag = true;
            // 清空附件缓存
            sessionStorage.removeItem("addAppendList");
            this.handleBack();
          }
        })
        .catch(e => {
          console.log(e);
        });
    }
  },
  // 更改列表缓存状态
  beforeRouteLeave(to, from, next) {
    if (this.submitFlag === true) {
      for (var key in this.$vnode.parent.componentInstance.cache) {
        delete this.$vnode.parent.componentInstance.cache[
          ishasAgentId(to.path, key)
        ];
      }
    }
    next();
  }
};
</script>
